import {put, take, select, fork} from 'redux-saga/effects';
import {alfAccountTypes, alfInvoiceStatusTypes, alfInvoiceTypes, persistenceStates} from '@ace-de/eua-entity-types';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as invoiceActionTypes from '../invoiceActionTypes';

const loadInvoice = function* loadInvoice({payload}) {
    const {match, location} = payload;
    const {invoiceId} = match.params;

    const {serviceManager} = yield select(state => state.application);
    const leaAssignmentFlowService = serviceManager.loadService('leaAssignmentFlowService');

    if (!invoiceId) return;

    // prevent showing empty side map panel
    yield put({
        type: invoiceActionTypes.SET_INVOICE_RELEVANT_LOCATIONS_PERSISTENCE_STATE,
        payload: {persistenceState: persistenceStates.PENDING},
    });

    yield fork(
        fetchRequest,
        invoiceActionTypes.FETCH_INVOICE_REQUEST,
        leaAssignmentFlowService.getInvoice,
        {invoiceId},
    );

    const invoiceFetchActionResponse = yield take([
        invoiceActionTypes.FETCH_INVOICE_REQUEST_SUCCEEDED,
        invoiceActionTypes.FETCH_INVOICE_REQUEST_FAILED,
    ]);

    if (!invoiceFetchActionResponse.error) {
        const {response} = invoiceFetchActionResponse.payload;
        const {invoiceDTO} = response;

        yield put({
            type: invoiceActionTypes.STORE_INVOICES,
            payload: {invoiceDTOs: [invoiceDTO]},
        });

        yield put({
            type: invoiceActionTypes.INITIATE_INVOICE_SCREEN_REDIRECTION,
            payload: {match, location},
        });

        if (invoiceDTO.status === alfInvoiceStatusTypes.IN_CREATION) {
            const {serviceCases, accountPartyOptionsIds} = yield select(state => state.serviceCases);
            const serviceCase = serviceCases[invoiceDTO.serviceCaseId];
            if (!serviceCase) return;

            yield put({
                type: invoiceActionTypes.FETCH_ACCOUNT_PARTY_OPTIONS,
                payload: {
                    accountPartyOptionsIds: [
                        ...accountPartyOptionsIds,
                        ...(!accountPartyOptionsIds.includes(serviceCase.member?.membershipNo)
                            ? [serviceCase.member.membershipNo]
                            : []),
                    ],
                    accountPartyType: invoiceDTO.type === alfInvoiceTypes.VKR
                        ? alfAccountTypes.DEBTOR
                        : alfAccountTypes.CREDITOR,
                    client: serviceCase.client,
                },
            });
        }
    }
};

export default loadInvoice;
